// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, OAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDOlF0pfplfkwC3mw93fBHW26E3SeWSFa4",
  authDomain: "it-sms-c5253.firebaseapp.com",
  projectId: "it-sms-c5253",
  storageBucket: "it-sms-c5253.appspot.com",
  messagingSenderId: "313178703559",
  appId: "1:313178703559:web:e82a70f5af2fcd3ec520e2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const firestore = getFirestore(app);
export const auth = getAuth(app);